module.exports = __webpack_public_path__ + "img/elasticbitcoin-Adaptive Supply.33f1dad6.svg";